(function($) {
  
  AjaxSolr.ResultWidget = AjaxSolr.AbstractWidget.extend({
    
    init: function() {
      $(document).on('click', 'a.more', function() {
        var $this = $(this), 
        span = $this.parent().find('span');
        
        if (span.is(':visible')) {
          span.hide();
          $this.text('more');
        } 
        else {
          span.show();
          $this.text('less');
        }

        return false;
      });

      this.fieldNames = {};
      for(var i = 1; i < 11; i++) {
        this.fieldNames["ac_title" + i] = "ac_text" + i;
        this.fieldNames["rg_title" + i] = "rg_text" + i;
      }
    },
    
    afterRequest: function() 
	{
      $(this.target).empty();
	  if(getLang() == 1)
		this.langPrefix = '!$1!:'
	  else
		this.langPrefix = '!$3!:'
      
      for (var i = 0, l = this.manager.response.response.docs.length; i < l; i++) {
        var doc = this.manager.response.response.docs[i];
        
        // Find the highlights for this doc
        var highlight = null;
        if(("highlighting" in this.manager.response) && (doc.id in this.manager.response.highlighting)) {
          highlight = this.manager.response.highlighting[doc.id];
        }
        $(this.target).append(this.template(doc, highlight));
      
      }
      $(this.target).scrollTop(0);      
      // Removing custom scrollbar classes for making it work
      // $('#docs').removeClass();
      // if ($('#docs').hasClass('mCustomScrollbar')) {
      //   $('#docs').mCustomScrollbar("update"); 
      // }

      // Adding custom scrollbar to the search results container
      // $(this.target).addClass("pager" + this.manager.widgets.pager.currentPage);
      // $(this.target + ".pager" + this.manager.widgets.pager.currentPage).mCustomScrollbar(); 
    },
    
    template: function(doc, highlight) {
      var snippet = '';
      for (var title in this.fieldNames) {
        if (title in doc) {
          var text = this.fieldNames[title];
          var titles = doc[title];
          var len = titles.length;
          var titleText = "FIELD_NAME";
          for(var i = 0; i < len; i++) {
            if(titles[i].lastIndexOf(this.langPrefix, 0) === 0) {
              titleText = titles[i].substring(this.langPrefix.length);
            }
          }
          
          snippet += '<div><span>' + titleText + ': </span><b>' + doc[text] + '</b></div>';
        }
      }
      
      // Date
      if ("curdate" in doc && doc.curdate > 0) {
          var d = new Date(567986400000 + doc.curdate * 60000); // 567986400000 midnight of January 1, 1988 - Beginning of time by Priority

          // Add 0 to the months if there is one number
        var month = (d.getMonth() + 1).toString(); // (+1 - month is zero based)

        if (month.length === 1) {
          month = "0" + month;
        }
        
        // Changing date format depends on language
        // Setting format for American English
        if (getLang() === 3) {
          snippet += '<div><span>' + get_message_string(961) + ': </span><b>'
                  + month + "/" + d.getDate() + "/" + d.getFullYear()
                  + '</b></div>';
        } else {
          // Setting format for all other languages
          snippet += '<div><span>' + get_message_string(961) + ': </span><b>'
                  + d.getDate() + "/" + month + "/" + d.getFullYear()
                  + '</b></div>';
        }

        // if ("curdate" in doc && doc.curdate > 0) {
        //   var d = new Date(567993600000 + doc.curdate * 60000); //567993600000 is the number of milliseconds between midnight of January 1, 1988 and midnight of January 1, 1970.
        //   snippet += '<div><span>' + get_message_string(961) + ': </span><b>'
        //           + d.getDate() + "/" + (1 + d.getMonth()) + "/" + d.getFullYear()
        //           + '</b></div>';
        // }
      }

      console.log('getLang()', getLang());
      
      // Status
      if ("statdes" in doc && doc.statdes !== "") {
          snippet += '<div><span>' + get_message_string(962) + ': </span><b>'
        	        + doc.statdes
	                + '</b></div>';
      }

      // Attachment
      if (doc.id.split(":").length == 5) {
    	    snippet += '<div><a target="_blank" href="' + getMailDirPath(doc.extfilename) 
    	    		+ '">' + get_message_string(963) + ': </a></div>'; //'Link to attachment'
      }
      
      // Freetext
      var lang_pfx = getLang() == 1 ? "_iw" : "_en";
      if (highlight && "freetext1" + lang_pfx in highlight) {
        snippet += '<div>';
        var len = highlight["freetext1" + lang_pfx].length;
        for (var i = 0; i < len; i++) {
          snippet += highlight["freetext1" + lang_pfx][i];
          if(i < len - 1) snippet += " ... ";
        }
        snippet += '</div>';
      }
      if (highlight && "freetext2" + lang_pfx in highlight) {
        snippet += '<div>';
        var len = highlight["freetext2" + lang_pfx].length;
        for (var i = 0; i < len; i++) {
          snippet += highlight["freetext2" + lang_pfx][i];
          if(i < len - 1) snippet += " ... ";
        }
        snippet += '</div>';
      }
      var p1 = $('<div/>', {
        class: 'fake-link',
        html: ("ac_text1" in doc) && (doc.ac_text1 !== doc.name) ? doc.ac_text1 + " (" + doc.name + ")" : doc.name
       
      })
      .click(function() {
        startEnt(doc.form, doc.name, doc.dname, 5);  // magic API for opening a form and zooming to the entity
        setTimeout(function(){ $('.hideEsearchBtn').click(); }, 1000);	
      });
      
	  
      var title = $('<h2/>').append(p1);
      
      if(!this.manager.hasFilter()) {
        var p2 = $('<div/>', {
          html: getBPMName(doc.form)
        });
        title.append(p2);
      }

      var $snippet = $('<p/>', {
        html: snippet
      });

      return $('<div/>').append(title).append($snippet);
    },
    
    start: 0
  
  });

})(jQuery);
